import PAAttendee from "./Attendee";


class ToDo {
    constructor(){

        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;

        this.created_by = "";
        this.title = "";
        this.notes = "";
        this.category = "General";
        this.assigned_to = "";
        this.priority = "Low";
        this.schedule_date = "";
        this.schedule_day = "";
        this.schedule_all_day = false;
        this.schedule_begin_time_selected = false;
        this.schedule_end_time_selected = false;
        this.schedule_begin_time = "";
        this.schedule_end_time = "";
        this.reminder_days_before_time_selected = false;
        this.reminder_days_before_array = [];
        this.reminder_days_before_time = "";
        this.reminder_day_of_time_selected = false;
        this.reminder_day_of_time = "";
        this.is_private = false;
        this.status = 1;

    }
}

export default ToDo;